import ajax from "@/ajax";

export default {
  me() {
    return ajax.get("/me").then(res => {
      return res.data;
    });
  }
};
